import RedirectToLive from "./RedirectToLive";
export default RedirectToLive;
